export const ButtonStyles = {
    backgroundColor: "#dc3545",
    color: "white",
    // borderRadius: 1.5,
    textTransform: "none",
    fontWeight: "600",
    px: 2,
    fontSize: "0.875rem",
    boxShadow: "0 2px 8px rgba(220, 53, 69, 0.3)",
    "&:hover": {
        backgroundColor: "#c82333",
        boxShadow: "0 4px 12px rgba(220, 53, 69, 0.4)",
        transform: "translateY(-1px)",
    }
};